export default "__VITE_ASSET__Dx42q40Q__"